function useOpenNewTab() {
    
    function openTab(action) {
        switch(action) {
            case 'PURCHASE': {
                return window.open(
                    'https://paradoxparlours.com/escape-rooms/online'
                )
            }

            case 'CONTACT': {
                return window.open(
                    'https://paradoxparlours.com/contact'
                )
            }
                
            case 'FACEBOOK': {
                return window.open(
                    'https://www.facebook.com/paradoxparlours/'
                )
            }
                
            case 'TWITTER': {
                return window.open(
                    'https://twitter.com/paradoxparlours'
                )
            }  
            
            case 'INSTAGRAM': {
                return window.open(
                    'https://www.instagram.com/paradoxparlours'
                )
            }  
                
            case 'TRIPADVISOR': {
                return window.open(
                    'https://www.tripadvisor.co.uk/Attraction_Review-g186390-d12706203-Reviews-Paradox_Parlours_formally_Guildford_Escape_Rooms-Guildford_Surrey_England.html'
                )
            }  

            default: {
                return null
            }
        }
    }
    
    return {openTab}
    
}

export default useOpenNewTab